import {
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  Typography
} from "@mui/material";

const ComparisonModal = ({open, onClose, comparisonData}) => {
  // Función para comparar objetos profundamente y encontrar diferencias
  // const findDifferences = (obj1, obj2, path = "") => {
  //   const differences = new Set();

  //   const compare = (o1, o2, currentPath) => {
  //     if (typeof o1 !== typeof o2) {
  //       differences.add(currentPath);
  //       return;
  //     }

  //     if (o1 === null || o2 === null) {
  //       if (o1 !== o2) differences.add(currentPath);
  //       return;
  //     }

  //     if (typeof o1 !== "object") {
  //       if (o1 !== o2) differences.add(currentPath);
  //       return;
  //     }

  //     const keys1 = Object.keys(o1 || {});
  //     const keys2 = Object.keys(o2 || {});
  //     const allKeys = new Set([...keys1, ...keys2]);

  //     allKeys.forEach((key) => {
  //       const newPath = currentPath ? `${currentPath}.${key}` : key;
  //       if (!(key in o1) || !(key in o2)) {
  //         differences.add(newPath);
  //       } else {
  //         compare(o1[key], o2[key], newPath);
  //       }
  //     });
  //   };

  //   compare(obj1, obj2, path);
  //   return differences;
  // };

  // Función para renderizar JSON con highlighting de diferencias
  const renderJsonWithDifferences = (data, differences, side) => {
    const jsonString = JSON.stringify(data, null, 2);
    const lines = jsonString.split("\n");

    return lines.map((line, index) => {
      const match = line.match(/"([^"]+)":/);
      let isDifferent = false;

      if (match) {
        const key = match[1];
        isDifferent = Array.from(differences).some((diff) => diff.includes(key));
      }

      const bgColor = isDifferent ? (side === "ts" ? "#fff3cd" : "#ffd4d4") : "transparent";
      const borderLeft = isDifferent ? `3px solid ${side === "ts" ? "#ffc107" : "#ff6b6b"}` : "none";

      return (
        <div
          key={index}
          style={{
            backgroundColor: bgColor,
            borderLeft: borderLeft,
            paddingLeft: isDifferent ? "8px" : "0",
            transition: "background-color 0.2s"
          }}
        >
          {line}
        </div>
      );
    });
  };

  if (!comparisonData) return null;

  const differences = comparisonData.differences || new Set();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>
        <Typography variant="h5" sx={{display: "flex", alignItems: "center", gap: 1}}>
          🔍 Comparación de Resultados
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={3}>
          {/* Columna AI TeamSystem */}
          <Grid item xs={12} md={6}>
            <Card variant="outlined" sx={{bgcolor: "info.50", height: "100%"}}>
              <CardContent>
                <Typography variant="h6" gutterBottom sx={{display: "flex", alignItems: "center", gap: 1}}>
                  🤖 AI TeamSystem
                </Typography>
                <Divider sx={{mb: 2}} />

                <Typography variant="caption" color="textSecondary" display="block" gutterBottom>
                  Archivo: {comparisonData.ts.fileName}
                </Typography>
                <Typography variant="caption" color="textSecondary" display="block" gutterBottom>
                  Fecha: {new Date(comparisonData.ts.timestamp).toLocaleString()}
                </Typography>

                {comparisonData.ts.result?.result?.processingTime && (
                  <Chip
                    label={`Tiempo: ${
                      typeof comparisonData.ts.result.result.processingTime === "string" &&
                      comparisonData.ts.result.result.processingTime.includes("ms")
                        ? (parseInt(comparisonData.ts.result.result.processingTime) / 1000).toFixed(2) + "s"
                        : comparisonData.ts.result.result.processingTime
                    }`}
                    color="info"
                    size="small"
                    sx={{mt: 1, mb: 2}}
                  />
                )}

                <Box sx={{mt: 2, p: 2, bgcolor: "white", borderRadius: 1, maxHeight: "400px", overflow: "auto"}}>
                  <Box sx={{display: "flex", alignItems: "center", gap: 1, mb: 1}}>
                    <Typography variant="caption" color="textSecondary" display="block">
                      Datos extraídos:
                    </Typography>
                    {differences && differences.size > 0 && (
                      <Chip label={`${differences.size} diferencias`} size="small" color="warning" />
                    )}
                  </Box>
                  <pre style={{fontSize: "13px", margin: 0, whiteSpace: "pre-wrap", fontFamily: "monospace"}}>
                    {differences
                      ? renderJsonWithDifferences(comparisonData.ts.result?.result?.data || {}, differences, "ts")
                      : JSON.stringify(comparisonData.ts.result?.result?.data || {}, null, 2)}
                  </pre>
                </Box>
              </CardContent>
            </Card>
          </Grid>

          {/* Columna AI Gemini */}
          <Grid item xs={12} md={6}>
            <Card variant="outlined" sx={{bgcolor: "success.50", height: "100%"}}>
              <CardContent>
                <Typography variant="h6" gutterBottom sx={{display: "flex", alignItems: "center", gap: 1}}>
                  ✨ AI Gemini
                </Typography>
                <Divider sx={{mb: 2}} />

                <Typography variant="caption" color="textSecondary" display="block" gutterBottom>
                  Archivo: {comparisonData.gemini.fileName}
                </Typography>
                <Typography variant="caption" color="textSecondary" display="block" gutterBottom>
                  Fecha: {new Date(comparisonData.gemini.timestamp).toLocaleString()}
                </Typography>

                <Box sx={{display: "flex", gap: 1, mt: 1, mb: 2, flexWrap: "wrap"}}>
                  {comparisonData.gemini.result?.result?.processingTime && (
                    <Chip
                      label={`Tiempo: ${
                        typeof comparisonData.gemini.result.result.processingTime === "string" &&
                        comparisonData.gemini.result.result.processingTime.includes("ms")
                          ? (parseInt(comparisonData.gemini.result.result.processingTime) / 1000).toFixed(2) + "s"
                          : comparisonData.gemini.result.result.processingTime
                      }`}
                      color="info"
                      size="small"
                    />
                  )}
                  {comparisonData.gemini.result?.result?.usage && (
                    <>
                      <Chip
                        label={`Tokens: ${comparisonData.gemini.result.result.usage.totalTokens.toLocaleString()}`}
                        color="warning"
                        size="small"
                      />
                      <Chip
                        label={`Coste: €${comparisonData.gemini.result.result.usage.cost.totalCost.toFixed(6)}`}
                        color="success"
                        size="small"
                      />
                    </>
                  )}
                </Box>

                <Box sx={{mt: 2, p: 2, bgcolor: "white", borderRadius: 1, maxHeight: "400px", overflow: "auto"}}>
                  <Box sx={{display: "flex", alignItems: "center", gap: 1, mb: 1}}>
                    <Typography variant="caption" color="textSecondary" display="block">
                      Datos extraídos:
                    </Typography>
                    {differences && differences.size > 0 && (
                      <Chip label={`${differences.size} diferencias`} size="small" color="warning" />
                    )}
                  </Box>
                  <pre style={{fontSize: "13px", margin: 0, whiteSpace: "pre-wrap", fontFamily: "monospace"}}>
                    {differences
                      ? renderJsonWithDifferences(
                          comparisonData.gemini.result?.result?.data || {},
                          differences,
                          "gemini"
                        )
                      : JSON.stringify(comparisonData.gemini.result?.result?.data || {}, null, 2)}
                  </pre>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        {differences && differences.size > 0 && (
          <Box sx={{mt: 3, p: 2, bgcolor: "grey.50", borderRadius: 1, border: 1, borderColor: "grey.300"}}>
            <Typography variant="caption" sx={{fontWeight: "bold", display: "block", mb: 1}}>
              📌 Leyenda de Diferencias:
            </Typography>
            <Box sx={{display: "flex", gap: 3, flexWrap: "wrap"}}>
              <Box sx={{display: "flex", alignItems: "center", gap: 1}}>
                <Box
                  sx={{
                    width: 20,
                    height: 20,
                    bgcolor: "#fff3cd",
                    border: "3px solid #ffc107",
                    borderRadius: 0.5
                  }}
                />
                <Typography variant="caption">Diferencias en AI TeamSystem</Typography>
              </Box>
              <Box sx={{display: "flex", alignItems: "center", gap: 1}}>
                <Box
                  sx={{
                    width: 20,
                    height: 20,
                    bgcolor: "#ffd4d4",
                    border: "3px solid #ff6b6b",
                    borderRadius: 0.5
                  }}
                />
                <Typography variant="caption">Diferencias en AI Gemini</Typography>
              </Box>
            </Box>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ComparisonModal;
